"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_redux_1 = require("react-redux");
const actions_1 = require("../../../modules/authorization/actions");
const types_1 = require("../../../modules/authorization/types");
const selectors_1 = require("../../../modules/authorization/selectors");
const AuthorizationModal_1 = require("./AuthorizationModal");
const AuthorizationModal_types_1 = require("./AuthorizationModal.types");
const utils_1 = require("./utils");
const mapState = (state, ownProps) => {
    const { authorization, requiredAllowance, getConfirmationStatus, getConfirmationError } = ownProps;
    return {
        revokeStatus: (0, utils_1.getStepStatus)(state, types_1.AuthorizationAction.REVOKE, authorization, undefined),
        grantStatus: (0, utils_1.getStepStatus)(state, types_1.AuthorizationAction.GRANT, authorization, requiredAllowance),
        confirmationStatus: getConfirmationStatus
            ? getConfirmationStatus(state)
            : AuthorizationModal_types_1.AuthorizationStepStatus.PENDING,
        confirmationError: getConfirmationError
            ? getConfirmationError(state)
            : null,
        error: (0, selectors_1.getAuthorizationFlowError)(state) || (0, selectors_1.getError)(state) || ''
    };
};
const mapDispatch = (dispatch, ownProps) => ({
    onRevoke: (traceId) => dispatch((0, actions_1.authorizationFlowRequest)(ownProps.authorization, types_1.AuthorizationAction.REVOKE, '', traceId)),
    onGrant: (traceId) => {
        var _a;
        return dispatch((0, actions_1.authorizationFlowRequest)(ownProps.authorization, types_1.AuthorizationAction.GRANT, ((_a = ownProps.requiredAllowance) === null || _a === void 0 ? void 0 : _a.toString()) || '', traceId));
    },
    onFetchAuthorizations: () => dispatch((0, actions_1.fetchAuthorizationsRequest)([ownProps.authorization]))
});
exports.default = (0, react_redux_1.connect)(mapState, mapDispatch)(AuthorizationModal_1.AuthorizationModal);
//# sourceMappingURL=AuthorizationModal.container.js.map